/**
 *
 * ScheduleAPickup
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { compose } from "redux";
import { Container, Row, Col } from "reactstrap";
import PickupTypes from "../PickupTypes/Loadable";
import PickupFormComponent from "forms/donor-schedule/index";
import injectReducer from "../../utils/injectReducer";
import reducer from "forms/donor-schedule/donor-schedule.reducer";
import injectSaga from "../../utils/injectSaga";
import saga from "../Pickups/saga";
import { Route } from "react-router-dom";

function ScheduleAPickup(props) {
  const { match } = props;

  return (
    <div>
      <Helmet>
        <title>ScheduleAPickup</title>
        <meta name="description" content="Description of ScheduleAPickup" />
      </Helmet>
      <Container className={"mt-2"}>
        <PickupTypes>
          <Route path={`${match.url}`} component={PickupFormComponent} />
        </PickupTypes>
        {/*<iframe id="pickup-iframe" style={{width: '100%', height: 'calc(100vh - 380px)', border: 'none'}} src="http://localhost:3009/schedule-new"></iframe>*/}
      </Container>
    </div>
  );
}

// ScheduleAPickup.propTypes = {
//   dispatch: PropTypes.func.isRequired,
// };

const mapStateToProps = (state) => ({
  user: state.user,
  locations: state.locations,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: "donorWizard", reducer });

export default compose(withReducer, withConnect)(ScheduleAPickup);
